import styled from '@emotion/styled'

 const DropdownContainer = styled.select`
    width: ${(props) =>
    props.DropdownWidth ? props.DropdownWidth : '15rem'};
    height: 2.25rem;
    position: relative;
    background-color: var(--color-white);
    padding-top: 0.2rem;
    padding-left: 0.5rem;
    border: 1px solid var(--color-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-6);
    -webkit-appearance: none; 
    background-image: url(/icons/chevron.svg);
    background-repeat: no-repeat;
    background-position: right 0.5rem top 50%;
   

`;

export default DropdownContainer;